import { z } from "zod";
import { SmartCreationReviewChangeSchema } from "./smart-creation-review/changes";

export * from "./smart-creation-review/changes";
export * from "./smart-creation-review/diagnostics";
export * from "./smart-creation-review/graph";
export * from "./smart-creation-review/suggestions";
export {
  isSmartCreationNegativeKeywordWithinWordLimit,
  type SmartCreationReviewBudgetAllocation,
  SmartCreationReviewBudgetAllocationSchema,
  type SmartCreationReviewEntityRef,
  SmartCreationReviewEntityRefSchema,
  type SmartCreationReviewNamingRule,
  SmartCreationReviewNamingRuleSchema,
  SmartCreationReviewSuggestedNumericRangeSchema,
} from "./smart-creation-review/values";
export * from "./smart-creation-review/workspace";

export const SmartCreationReviewBatchChangeInputSchema = z
  .object({
    expectedPlanRevision: z.number().int().positive(),
    expectedWorkspaceRevision: z.number().int().positive(),
    clientMutationId: z.string().uuid(),
    changes: z.array(SmartCreationReviewChangeSchema).min(1).max(100),
  })
  .strict();
export type SmartCreationReviewBatchChangeInput = z.infer<
  typeof SmartCreationReviewBatchChangeInputSchema
>;
export type SmartCreationReviewEditChange = SmartCreationReviewBatchChangeInput["changes"][number];

export const SmartCreationReviewRefreshPreviewInputSchema = z
  .object({ expectedPlanRevision: z.number().int().positive() })
  .strict();
export type SmartCreationReviewRefreshPreviewInput = z.infer<
  typeof SmartCreationReviewRefreshPreviewInputSchema
>;
